'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _neptune = require('./neptune');

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require('./_n');

var _n3 = _interopRequireDefault(_n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_neptune2.default.transport = {
  init: function init(p) {

    p = p || document;

    _neptune2.default.debug.info('transport:init', { el: p });

    _n3.default.qsa('[neptune-transport]', p).forEach(function (el) {

      var _transport = [{}];

      try {
        _transport = USON.parse(el.getAttribute('neptune-transport').replace(/'/g, '"').replace(/`/g, "'").replace(/</g, '[').replace(/>/g, ']'), 'array')[0];
      } catch (error) {}

      if (!!_transport.breakpoints) {

        var onbreak = _n3.default.debounce(function () {
          _neptune2.default.transport.action(el, _transport);
        }, 250);

        window.addEventListener('resize', onbreak);
      }

      _neptune2.default.transport.action(el, _transport);
    });
  },
  action: function action(el, _transport) {

    // if(el.parentNode.classList.contains('transport-recipient')) return false;

    _transport = _n3.default.copy(_transport);

    // handle breakpoints
    if (!!_transport.breakpoints) {
      var vbps = Object.keys(_transport.breakpoints).filter(function (b) {
        return b < window.innerWidth;
      }).reverse();
      if (vbps.length) {
        for (var key in _transport.breakpoints[vbps[0]]) {
          _transport[key] = _transport.breakpoints[vbps[0]][key];
        }
      }
    }

    if (_n3.default.exists(_transport.before)) {
      _n3.default.qs(_transport.before).before(el);
      _n3.default.qs(_transport.before).parentNode.classList.add('transport-recipient');
    }

    if (_n3.default.exists(_transport.after)) {
      _n3.default.qs(_transport.after).after(el);
      _n3.default.qs(_transport.after).parentNode.classList.add('transport-recipient');
    }

    if (_n3.default.exists(_transport.append)) {
      _n3.default.qs(_transport.append).append(el);
      _n3.default.qs(_transport.append).classList.add('transport-recipient');
    }

    if (_n3.default.exists(_transport.prepend)) {
      _n3.default.qs(_transport.prepend).prepend(el);
      _n3.default.qs(_transport.prepend).classList.add('transport-recipient');
    }

    if (_n3.default.exists(_transport.replace)) {
      _n3.default.qs(_transport.replace).innerHTML = '';
      _n3.default.qs(_transport.replace).append(el);
      _n3.default.qs(_transport.replace).classList.add('transport-recipient');
    }
  }

  // document.addEventListener('periscope:preview', e => {
  //   _n.qsa('.transport-recipient [neptune-transport]',e.detail.info.el).forEach( el => {
  //     document.body.append(el)
  //     console.log('transported out', el)
  //   })
  // })
  // _n.trigger(document,'periscope:preview',false,true,{el:el,url:url,meta:meta})

};window.Neptune = _neptune2.default;

exports.default = _neptune2.default.debug;